<app-search-select
  [label]="branchLabel"
  [showDefaultListValue]="showDefaultListValue"
  [showNoneOption]="showNoneOption"
  [defaultLabel]="defaultLabel"
  [defaultSelected]="defaultSelected"
  (emitSelectedVal)="emitSelected($event)"
  [control]="control"
  [type]="type"
  [fetchedList]="branchesData"
  [endpoint]="endpoint"
  [disabled]="disabled"
></app-search-select>
